import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom-v5-compat';
import { Text, TextType } from 'ui-components/components/text';
import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import style from '../../style.module.less';

/**
 * Reusable information component that displays text and a button
 * @param {object} props
 * @param {object} props.textMessage - The message object for the text content
 * @param {object} props.buttonMessage - The message object for the button text
 * @param {string} props.buttonLink - The navigation link for the button
 * @param {string} [props.className] - Optional className for the wrapper
 * @param {string} [props.buttonClassName] - Optional className for the button
 * @returns {JSX.Element}
 */

export const Information = ({ textMessage, buttonMessage, buttonLink, className, buttonClassName }) => {
  const navigate = useNavigate();

  return (
    <div className={className}>
      <Text textType={TextType.Paragraph} value={<FormattedMessage {...textMessage} />} />
      <Button
        className={buttonClassName ?? style['helpfullinks-section-button']}
        onClick={() => navigate(buttonLink)}
        theme={THEME_CONSTANTS.link}
      >
        <span className={style['helpfullinks-button-text']}>
          <FormattedMessage {...buttonMessage} />
        </span>
        <FontAwesomeIcon icon={faChevronRight} />
      </Button>
    </div>
  );
};
